import { atom } from 'jotai';
import type { DcaHotkeyMapping } from '../../utils';

/**
 * Hotkeys mode state. While `active` is false no DCA hotkey does anything, so
 * typing in the workspace cannot change a forecast parameter by accident.
 * `mapping` picks which set of parameter keys applies.
 */
export const dcaHotkeysModeAtom = atom<{
  active: boolean;
  mapping: DcaHotkeyMapping;
}>({ active: false, mapping: 'insights' });

/** Whether the hotkeys cheatsheet overlay is showing. */
export const dcaHotkeysHelpOpenAtom = atom(false);

/**
 * Counter that the save hotkey increments. `ConfigurationPanel` builds the save
 * payload, so it watches this count and saves when the count changes.
 */
export const dcaSaveRequestAtom = atom(0);
